import { render, staticRenderFns } from "./OfficeView.vue?vue&type=template&id=622d5c17&scoped=true"
import script from "./OfficeView.vue?vue&type=script&lang=js"
export * from "./OfficeView.vue?vue&type=script&lang=js"
import style0 from "./OfficeView.vue?vue&type=style&index=0&id=622d5c17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d5c17",
  null
  
)

export default component.exports